// ============ التكريمات والجوايز (سلايدر بيتحرك لوحده في الهوم وصفحة من نحن) ============
// 1) حط صور التكريمات في فولدر public/awards بالأسماء اللي تحت (award-1.jpg, award-2.jpg ...)
//    أو غيّر المسار هنا لأي اسم. أي صورة مش موجودة بتختفي لوحدها، ولو مفيش ولا صورة القسم كله مبيظهرش.
// 2) title و by و year اختياريين: لو كتبتهم بيظهروا تحت الصورة.
//    title و by ممكن يبقوا نص عادي أو M("English", "عربي", ...) لو عايزهم مترجمين.
// مقاس مقترح للصورة: 1200×1500 (طولي) أو 1500×1200 (عرضي)، jpg أو webp أقل من 400KB.
import { M } from "./Developersdata";

export const AWARDS = [
    {
    img: "/awards/awardnew1.jpeg",
    title: M("Some Our  Recognition Awards", "جوائز تكريم الوسطاء"),
 by: M("Best Awards", "Favourate Awards"),
     year:2026 ,
  },
    {
    img: "/awards/awardnew2.jpeg",
    title: M("Binghatti Recognition Awards", "جوائز تكريم الوسطاء"),
 by: M("Binghatti", "بن غاطي"),
     year:2026 ,
  },
  
  {
    img: "/awards/award-1.jpg",
    title: M("Broker Recognition Awards", "جوائز تكريم الوسطاء"),
    by: M("Binghatti", "بن غاطي"),
    year: 2026,
  },
  {
    img: "/awards/award-2.jpg",
    title: M("Channel Partnership Award", "جائزة شركاء القنوات"),
    by: M("Azizi", "عزيزي"),
    year: null,
  },
  {
    img: "/awards/award-3.jpg",
    title: M("Broker Recognition Award · Property Show II", "جائزة تكريم الوسطاء · معرض العقارات الثاني"),
    by: M("Binghatti", "بن غاطي"),
    year: null,
  },
  // اسم الجايزة دي مش باين في الصورة: اكتبه في title و by لو عايزه يظهر
  { img: "/awards/award-4.jpg", title: "", by: "", year: null },
];

// مثال لتكريم بعنوان مترجم:
// { img: "/awards/emaar-2025.jpg", title: M("Top Broker 2025", "أفضل وسيط 2025"), by: "Emaar", year: 2025 },
export { M };

// كل كام ثانية السلايدر يتحرك
export const AWARDS_INTERVAL = 3200;
